// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3pcB1","dragIcon":"Choice_dragIcon__un1Wf","left":"Choice_left__2h1pY","input":"Choice_input__2OCgz"};